// extracted by mini-css-extract-plugin
var _1 = "JQkbV2sX";
export { _1 as "keyboard" }
